import { AlertCircleIcon } from 'lucide-react';
import { useSnapshot } from 'valtio';

import { authState } from '../../../services/state/auth-state.jsx';
import { useQueryActiveCampaign } from '../../../hooks/queries/use-active-campaign.jsx';
import { CATALYST_USER_ROLES } from '../../../utils/constants.js';

export const BackOfficePermissionsRedirectWrapper = ({ children }) => {
  const { user } = useSnapshot(authState);
  const activeCampaign = useQueryActiveCampaign();

  const userRole = user?.details?.role;

  if (
    userRole === CATALYST_USER_ROLES.user &&
    !activeCampaign?.data?.operatorPermissions
  ) {
    return (
      <div className="flex w-full flex-col items-center justify-center">
        <AlertCircleIcon className="size-20" />
        <h1 className="py-6 text-xl">
          Não tem permissões para ver esta informação
        </h1>
      </div>
    );
  }

  return children;
};
